import { useBaseLayoutController } from './base-layout-controller';

/**
 * Hook para acessar as funcionalidades do BaseLayout em qualquer componente
 * que esteja dentro do BaseLayoutProvider.
 *
 * Este hook fornece acesso aos métodos:
 * - showDialog: Exibir diálogos de confirmação
 * - showMessage: Exibir mensagens toast/snackbar
 * - showLoading: Controlar o estado de loading
 *
 * @example
 * ```tsx
 * const MyComponent = () => {
 *   const { showDialog, showMessage, showLoading } = useBaseLayout();
 *
 *   const handleAction = async () => {
 *     showLoading({ open: true });
 *     try {
 *       await someAction();
 *       showMessage({ message: 'Sucesso!', type: 'success' });
 *     } catch (error) {
 *       showMessage({ message: 'Erro!', type: 'error' });
 *     } finally {
 *       showLoading({ open: false });
 *     }
 *   };
 *
 *   return <button onClick={handleAction}>Executar</button>;
 * };
 * ```
 */
export function useBaseLayout() {
    const controller = useBaseLayoutController();

    return {
        showDialog: controller.showDialog,
        showMessage: controller.showMessage,
        showLoading: controller.showLoading,
        hideDialog: controller.hideDialog,
        hideMessage: controller.hideMessage,
        hideLoading: controller.hideLoading,
    };
}
